/**
 * Display metadata for schedule-event types: a brand Ionicons name + short label.
 * Icons live here (not raw in screens) so screens stay declarative. Names are
 * valid @expo/vector-icons Ionicons. Pure data — no styling values.
 */
import type { ScheduleEventType } from '@beam/api-types';

type EventTypeMeta = { icon: string; label: string };

export const SCHEDULE_EVENT_META: Record<ScheduleEventType, EventTypeMeta> = {
  site_visit: { icon: 'navigate-outline', label: 'Site visit' },
  work: { icon: 'hammer-outline', label: 'Work' },
  inspection: { icon: 'search-outline', label: 'Inspection' },
  proposal_due: { icon: 'document-text-outline', label: 'Proposal due' },
  permit_followup: { icon: 'shield-checkmark-outline', label: 'Permit follow-up' },
  noc_deadline: { icon: 'alert-circle-outline', label: 'NOC deadline' },
  service_call: { icon: 'construct-outline', label: 'Service call' },
};

export function scheduleEventMeta(type: string): EventTypeMeta {
  return (
    SCHEDULE_EVENT_META[type as ScheduleEventType] ?? {
      icon: 'calendar-outline',
      label: type,
    }
  );
}

export const SCHEDULE_EVENT_TYPE_OPTIONS: ReadonlyArray<{ value: ScheduleEventType; label: string }> = (
  Object.keys(SCHEDULE_EVENT_META) as ScheduleEventType[]
).map((t) => ({ value: t, label: SCHEDULE_EVENT_META[t].label }));
